<template>
  <svg
    width="10"
    height="12"
    viewBox="0 0 10 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 0C3.67438 0.00141795 2.40348 0.498575 1.46613 1.3824C0.528771 2.26623 0.00150383 3.46455 0 4.71447C0 8.74855 4.54545 11.7969 4.73864 11.9255C4.81606 11.9741 4.90699 12 5 12C5.09301 12 5.18394 11.9741 5.26136 11.9255C5.45455 11.7969 10 8.74855 10 4.71447C9.9985 3.46455 9.47123 2.26623 8.53387 1.3824C7.59652 0.498575 6.32562 0.00141795 5 0ZM5 3.00012C5.3596 3.00012 5.71113 3.10066 6.01013 3.28904C6.30913 3.47741 6.54217 3.74516 6.67978 4.05841C6.81739 4.37167 6.8534 4.71637 6.78325 5.04892C6.71309 5.38147 6.53993 5.68694 6.28565 5.9267C6.03137 6.16646 5.7074 6.32973 5.35471 6.39588C5.00202 6.46203 4.63644 6.42808 4.30421 6.29832C3.97198 6.16857 3.68802 5.94884 3.48824 5.66691C3.28845 5.38499 3.18182 5.05354 3.18182 4.71447C3.18182 4.25979 3.37338 3.82374 3.71435 3.50224C4.05533 3.18074 4.51779 3.00012 5 3.00012Z"
      fill="#95CA51"
    />
  </svg>
</template>
